selectedWorkordersService.vsName = 'selectedWorkordersService'
selectedWorkordersService.vsNgType = 'factory'

selectedWorkordersService.$inject = ['collection']
function selectedWorkordersService(collection){
  return new collection('Id', 'machineAdded', 'machineRemoved', 'selectedMachinesChanged')
}

export default selectedWorkordersService
